module.exports = __webpack_public_path__ + "static/media/in-call.212af288.gif";